<template>
  <div class="h-100" id="appRoot" v-on:resize="getWidth">
    <template v-if="!$route.meta.public && !loading">
      <v-app id="inspire" class="app">
        <app-toolbar/>
        <v-main class="mt-8">
          <v-row class="pa-0 page-wrapper">
            <v-col cols="2" class="pa-0 pt-2">
              <app-drawer/>
            </v-col>
            <v-col cols="10">
              <router-view/>
            </v-col>
          </v-row>
        </v-main>
      </v-app>
    </template>
    <template v-else-if="!loading">
      <v-app id="inspire" class="app">
        <app-toolbar/>
        <v-main class="mt-8">
          <v-row class="pa-0 page-wrapper">
            <v-col cols="12">
              <router-view/>
            </v-col>
          </v-row>
        </v-main>
      </v-app>
    </template>
    <error-dialog :global-error-dialog="globalErrorDialog"
                  :global-error-message="globalErrorMessage"
                  @click="setGlobalErrorMessage"
    />
    <v-app v-if="loading">
      <loading/>
    </v-app>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import Loading from "@/views/Loading";

export default {
  components: {
    Loading,
    AppDrawer,
    AppToolbar,
  },
  data: () => ({
    width: 0,
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
  }),
  computed: {
    ...mapGetters(['loading', 'globalErrorMessage', 'globalErrorDialog','errorMessages'])
  },
  watch: {
    width() {
      this.setWindowWidth(this.width);
    }
  },
  methods: {
    ...mapActions(['setGlobalErrorMessage','setWindowWidth', 'init']),
    getWidth() {
      window.onresize = () => {
        this.width = document.body.clientWidth;
      };
    },
    handleDrawerVisible() {
      this.showDrawer = !this.showDrawer
    },
  },
  created() {
    this.init()
    this.getWidth();

    let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    document.getElementsByTagName('head')[0].appendChild(link);

    this.width = document.body.clientWidth;


    window.getApp = this;
    console.log(this.width)



    // if (!localStorage.getItem('token')) {
    //   this.$store.dispatch("logout");
    //   this.$router.push("/login");
    // }

    // this.$http.interceptors.response.use(
    //     response => {
    //       return response;
    //     },
    //     err => {
    //       return new Promise((resolve, reject) => {
    //         if (err?.response?.status === 401 || err?.response?.status === 403) {
    //           this.$store.dispatch("logout");
    //           this.$router.push("/login");
    //         } else {
    //           reject(err);
    //         }
    //       });
    //     }
    // );
  },
};
</script>


